import { IntegrityMonitorRealTimePanelWebComponent } from './component/IntegrityMonitorRealTimePanelWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_REAL_TIME_PANEL } from '../../../../webcomponents.constants';

export { IntegrityMonitorRealTimePanelWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_REAL_TIME_PANEL,
  IntegrityMonitorRealTimePanelWebComponent
);
